class AdpCircleIconController {
  constructor() {
    this.name = 'adpCircleIcon';
  }
}

export default AdpCircleIconController;



// WEBPACK FOOTER //
// ./src/app/components/adpCircleIcon/adpCircleIcon.controller.js